import { combineReducers } from 'redux';
import { filterActions } from 'redux-ignore';
import { routerReducer } from 'react-router-redux';
import { bindingsReducer } from 'simple-iso-fetch';
import * as actionTypes from '../actionTypes';

import labels from './labels';
import staticData from './staticData';
import prelimApplication from './prelimApplication';
import admin from './admin';
import tempState from './tempState';
import user from './user';
import profile from './profile';
import applicantProfile from './applicantProfile';
import company from './company';
import jobRequest from './jobRequest';
import jobRequests from './jobRequests';
import companyJobRequests from './companyJobRequests';
import jobRequestDocuments from './jobRequestDocuments';
import companyContacts from './companyContacts';
import jobRequestHistory from './jobRequestHistory';
import browserData from './browserData';
import workExperiences from './workExperience';
import employmentGaps from './employmentGaps';
import education from './education';
import skills from './skills';
import licenses from './licenses';
import documents from './documents';
import associations from './professionalAssociations';
import designations from './professionalDesignations';
import behavioralAnswers from './behavioralAnswers';
import workObjectives from './workObjectives';
import references from './references';
import interviews from './interviews';
import ratings from './ratings';
import assessments from './assessments';
import applicantUser from './applicantUser';
import placementSpecialists from './placementSpecialists';
import alerts from './alerts';
import worksheets from './worksheets';
import ui from './ui';
import technologySurvey from './technologySurvey';
import assessmentUrls from './assessmentUrls';
import pins from './pins';
import employees from './employees';

const contactProfile = combineReducers({
  user: filterActions(user, [actionTypes.UPDATE_USER, actionTypes.UPDATE_IMPERSONATE_USER, actionTypes.UPDATE_APPLICANT, actionTypes.LOG_OUT]),
  profile: filterActions(profile, [actionTypes.UPDATE_APPLICANT, actionTypes.CLEAR_APPLICANT, actionTypes.LOG_OUT, actionTypes.UPDATE_PROFILE]),
  company: filterActions(company, [actionTypes.UPDATE_COMPANY, actionTypes.LOG_OUT])
});

export default combineReducers({
  user: filterActions(user, [actionTypes.UPDATE_USER, actionTypes.UPDATE_IMPERSONATE_USER, actionTypes.UPDATE_APPLICANT, actionTypes.LOG_OUT]),
  profile: filterActions(profile, [actionTypes.UPDATE_APPLICANT, actionTypes.UPDATE_PROFILE, actionTypes.CLEAR_APPLICANT, actionTypes.LOG_OUT]),
  company: filterActions(company, [actionTypes.UPDATE_COMPANY, actionTypes.LOG_OUT]),
  contactProfile,
  applicantProfile: filterActions(applicantProfile, [actionTypes.UPDATE_APPLICANT, actionTypes.CLEAR_APPLICANT, actionTypes.LOG_OUT]),
  jobRequest: filterActions(jobRequest, [actionTypes.CREATE_JOB_REQUEST, actionTypes.UPDATE_JOB_REQUEST, actionTypes.RESET_JOB_REQUEST, actionTypes.LOG_OUT]),
  jobRequests: filterActions(jobRequests, [actionTypes.UPDATE_JOB_REQUESTS, actionTypes.LOG_OUT]),
  companyJobRequests: filterActions(companyJobRequests, [actionTypes.UPDATE_COMPANY_JOB_REQUESTS, actionTypes.LOG_OUT]),
  jobRequestDocuments: filterActions(jobRequestDocuments, [actionTypes.CREATE_JOB_REQUEST_DOCUMENTS, actionTypes.UPDATE_JOB_REQUEST_DOCUMENTS, actionTypes.RESET_JOB_REQUEST_DOCUMENTS, actionTypes.LOG_OUT]),
  companyContacts: filterActions(companyContacts, [actionTypes.UPDATE_COMPANY_CONTACTS, actionTypes.LOG_OUT]),
  jobRequestHistory: filterActions(jobRequestHistory, [actionTypes.UPDATE_COMPANY_JOBS, actionTypes.FILTER_COMPANY_JOBS, actionTypes.LOG_OUT]),
  prelimApplication: filterActions(prelimApplication, [actionTypes.UPDATE_PRELIM_FORM]),
  admin: filterActions(admin, [actionTypes.UPDATE_APPLICANTS_PAGE, actionTypes.ADD_APPLICANT_ADMIN, actionTypes.DELETE_APPLICANT_ADMIN,
    actionTypes.UPDATE_APPLICANTS_LIST, actionTypes.UPDATE_CONTACTS_LIST, actionTypes.UPDATE_COMPANIES_LIST,
    actionTypes.UPDATE_CONTACTS_PAGE, actionTypes.UPDATE_COMPANIES_PAGE, actionTypes.UPDATE_CONTACT_IN_CONTACT_WORKSHEET, actionTypes.CLEAR_CONTACT_IN_CONTACT_WORKSHEET,
    actionTypes.UPDATE_COMPANY, actionTypes.UPDATE_CONTACT, actionTypes.UPDATE_APPLICANT_ADMIN, actionTypes.UPDATE_CURRENT_APPLICANT_ADMIN,
    actionTypes.UPDATE_EVENT_LIST, actionTypes.UPDATE_CONTACT_EVENT_LIST, actionTypes.CHANGE_NAV_COLUMN_STATE, actionTypes.UPDATE_PINNED_APPLICANTS,
    actionTypes.FETCH_PINNED_APPLICANTS, actionTypes.GET_COMPANY_INFO, actionTypes.LOG_OUT,
    actionTypes.UPDATE_CONTACTS_TABLE_SEARCH_TERMS,
    actionTypes.UPDATE_CONTACTS_TABLE_FILTERS,
    actionTypes.UPDATE_COMPANIES_TABLE_SEARCH_TERMS,
    actionTypes.UPDATE_COMPANIES_TABLE_FILTERS,
    actionTypes.UPDATE_JOB_REQUESTS_FILTERS, actionTypes.UPDATE_JOB_REQUESTS_TERMS,
    actionTypes.GO_TO_CONTACTS_PAGE,
  ]),
  pins: filterActions(pins, [actionTypes.LOAD_PINS, actionTypes.UPDATE_PINS]),
  tempState: filterActions(tempState, [actionTypes.UPDATE_TEMP_STATE, actionTypes.UPDATE_APPLICANT]),
  applicantUser: filterActions(applicantUser, [actionTypes.UPDATE_APPLICANT, actionTypes.CLEAR_APPLICANT, actionTypes.LOG_OUT]),
  employmentGaps,
  workExperiences,
  education,
  skills,
  licenses,
  documents,
  associations,
  designations,
  behavioralAnswers,
  workObjectives,
  references,
  interviews,
  ratings,
  assessments,
  placementSpecialists,
  alerts: filterActions(alerts, [actionTypes.UPDATE_ALERTS, actionTypes.LOG_OUT]),
  staticData: filterActions(staticData, [actionTypes.UPDATE_STATIC_DATA]),
  labels: filterActions(labels, [actionTypes.UPDATE_LABELS]),
  browserData: filterActions(browserData, [actionTypes.GET_SCROLLBAR_WIDTH, actionTypes.SET_USERAGENT]),
  worksheets: filterActions(worksheets, [actionTypes.UPDATE_WORKSHEET, actionTypes.REMOVE_WORKSHEET, actionTypes.LOG_OUT]),
  ui,
  employees,
  technologySurvey,
  assessmentUrls,
  routing: routerReducer,
  simpleIsoFetch: bindingsReducer,
});



// WEBPACK FOOTER //
// ./shared/redux/reducers/index.js